<template id="landingLoginTmpl">
	<ct-main-layout-login>
		
		
		<v-row no-gutters class="mt-10">
			<v-col cols="12" sm="6" md="4"  offset-sm="3" offset-md="4">
				<h1 class="loginTitle">{{$t('lbl.login_title')}}</h1>
			</v-col>
		</v-row>
		<v-row no-gutters class="mt-3">
			<v-col cols="12" sm="6" md="4"  offset-sm="3" offset-md="4">
				<v-form>
				<v-card>
					<v-card-title>
						{{$t('lbl.login_subtitle')}}
					</v-card-title>	
					<v-card-text>
						
							<v-row no-gutters>
								<v-col cols="12">
									<v-text-field v-model="user.username" label="Username" prepend-icon="person" ></v-text-field>
								</v-col>
							</v-row>		
							<v-row no-gutters>
								<v-col cols="12">	
									<v-text-field v-model="user.password" :type="'password'" label="Password" prepend-icon="lock"></v-text-field>
								</v-col>
							</v-row>
					</v-card-text>
					<v-divider></v-divider>	
					<v-card-actions>
									
							<v-row>
								<v-col cols="12" md="6" class="text-center">
									<v-btn class="button-main" v-on:click="doLogin()" >
										<v-icon left dark>login</v-icon>
										{{ $t('btn.login')}}
									</v-btn>
								</v-col>

								<v-col cols="12" md="6" class="text-center">
									<v-menu offset-x>
									<template v-slot:activator="{ on }">	  	  

									<v-btn class="button-main"  v-on="on">
										<v-icon left dark>language</v-icon>
										{{ $t('drawer.language')}}
									</v-btn>

									</template>	
									<v-list>
									<v-list-item @click="$root.changeLocale('en_US')">
										<v-list-tile>ENG</v-list-tile>
									</v-list-item>
									<v-list-item @click="$root.changeLocale('it_IT')">
										<v-list-tile>ITA</v-list-tile>
									</v-list-item>
									</v-list>
									</v-menu>
								</v-col>
								
								
							</v-row>	
						
					</v-card-actions>
				</v-card>
				</v-form>
			</v-col>
		</v-row>	
		
		<ct-sponsors></ct-sponsors>

		
	</ct-main-layout-login>
</template>
<script>
import i18n from '@/i18n';
import {events} from '@/event-bus.js';
import constants from '@/ctConstants.js';

export default {
	i18n,
	data: () => ({
		user: {username:'', password:''},
	}),
	methods: {
		doLogin() {
			this.$root.loading = true; 
			this.axios
			.get(constants.ENDPOINT_LOGIN, {params: this.user})
			.then((response) => {
				try{
					if(response.status == 200)
					{
						if(!this.isEmptyObj(response.data) && !this.isEmptyObj(response.data.AuthenticationResult) && !this.isEmptyString(response.data.AuthenticationResult.AccessToken))
						{
							console.log(response.data);
							var userObj = this.createUserObj(this.user.username, response.data);
							this.setUser(userObj);
							this.$root.goToPage("/apps");
						}
						else 
						{
							this.$root.setDialogMsg(i18n.t('err.accessdenied'));
						}
					} 
					else 
					{
						this.$root.setDialogMsg(i18n.t('err.accessdenied'));
					}
				} catch(error) { 
					this.$root.catchGenericError(error); 
				}
				finally { 
					this.$root.loading = false; 
				}
			});
					
		},
		createUserObj(username, responseData)
        {
            var userObj = {username: username};
			userObj.AuthenticationResult = responseData.AuthenticationResult;
			userObj.Roles = responseData.Roles;
			userObj.Applications = responseData.Applications;
			userObj.User = responseData.User;
			return userObj;
        },
	}
}
</script>